module.exports = __webpack_public_path__ + "static/architecture-4d8a6f8681bae2bec1aa49ed493430ed.png";